import { Routes } from '@angular/router'

import { MsalGuard } from '@azure/msal-angular'

export const APP_ROUTES: Routes = [
  // home page is available without authentication
  { path: '', pathMatch: 'full', loadChildren: () => import('./components/home/home.routes').then(m => m.HOME_ROUTES) },
  // The MSAL redirect bridge lives at this path, but main.ts handles it before the app ever boots. Reaching
  // the router here means someone opened it without an authorization response, so send them home rather
  // than leave them on a dead url. Must stay outside the MsalGuard block below.
  { path: 'redirect', pathMatch: 'full', redirectTo: '' },
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      // list all the pages requiring authentication here

      // core
      { path: 'countries', loadChildren: () => import('./components/core/countries/countries.routes').then(m => m.COUNTRIES_ROUTES) },
      { path: 'admin-zones-1', loadChildren: () => import('./components/core/admin-zones-1/admin-zones-1.routes').then(m => m.ADMIN_ZONES_1_ROUTES) },
      { path: 'admin-zones-2', loadChildren: () => import('./components/core/admin-zones-2/admin-zones-2.routes').then(m => m.ADMIN_ZONES_2_ROUTES) },
      { path: 'acted-areas', loadChildren: () => import('./components/core/acted-areas/acted-areas.routes').then(m => m.ACTED_AREAS_ROUTES) },
      { path: 'map', loadChildren: () => import('./components/core/main-map/main-map.routes').then(m => m.MAIN_MAP_ROUTES) },
      { path: 'places', loadChildren: () => import('./components/core/places/places.routes').then(m => m.PLACES_ROUTES) },
      { path: 'meal-sub-places', loadChildren: () => import('./components/ame/ame-sub-places/ame-sub-places.routes').then(m => m.AME_SUB_PLACES_ROUTES) },

      { path: 'roles', loadChildren: () => import('./components/roles/roles.routes').then(m => m.ROLES_ROUTES) },

      // hr
      {
        path: 'hr/staff-impact-user-accesses',
        loadChildren: () => import('./components/hr/staff-impact-user-accesses/staff-impact-user-accesses.routes')
          .then(m => m.STAFF_IMPACT_USER_ACCESSES_ROUTES),
      },
      {
        path: 'hr/staff-recommendation',
        loadChildren: () => import('./components/hr/staff-recommendation/staff-recommendation.routes').then(m => m.STAFF_RECOMMENDATION_ROUTES),
      },
      {
        path: 'hr/staff-recommendation-user-accesses',
        loadChildren: () => import('./components/hr/staff-recommendation-user-accesses/staff-recommendation-user-accesses.routes')
          .then(m => m.STAFF_RECOMMENDATION_USER_ACCESSES_ROUTES),
      },
      { path: 'hr/staff-national', loadChildren: () => import('./components/hr/staff-national/staff-national.routes').then(m => m.STAFF_NATIONAL_ROUTES) },
      {
        path: 'hr/staff-national-changes',
        loadChildren: () => import('./components/hr/staff-national-changes/staff-national-changes.routes').then(m => m.STAFF_NATIONAL_CHANGES_ROUTES),
      },
      {
        path: 'hr/staff-national-user-accesses',
        loadChildren: () => import('./components/hr/staff-national-user-accesses/staff-national-user-access.routes').then(m => m.STAFF_NATIONAL_USER_ACCESS_ROUTES),
      },
      { path: 'hr/staff-hq', loadChildren: () => import('./components/hr/staff-hq/staff-hq.routes').then(m => m.STAFF_HQ_ROUTES) },
      { path: 'hr/staff-impact', loadChildren: () => import('./components/hr/staff-impact/staff-impact.routes').then(m => m.STAFF_IMPACT_ROUTES) },
      { path: 'hr/world-directory', loadChildren: () => import('./components/hr/world-directory/world-directory.routes').then(m => m.WORLD_DIRECTORY_ROUTES) },
      { path: 'hr/focal-points', loadChildren: () => import('./components/hr/focal-points/focal-points.routes').then(m => m.FOCAL_POINTS_ROUTES) },
      { path: 'hr/my-leaves', loadChildren: () => import('./components/hr/my-leaves/my-leaves.routes').then(m => m.MY_LEAVES_ROUTES) },
      {
        path: 'hr/visa-restriction-assignments',
        loadChildren: () => import('./components/hr/visa-restriction-assignments/visa-restriction-assignments.routes')
          .then(m => m.VISA_RESTRICTION_ASSIGNMENTS_ROUTES),
      },
      {
        path: 'hr/direct-flights',
        loadChildren: () => import('./components/hr/direct-flights/direct-flights.routes').then(m => m.DIRECT_FLIGHTS_ROUTES),
      },
      {
        path: 'hr/visa-search',
        loadChildren: () => import('./components/hr/visa-search/visa-search.routes').then(m => m.VISA_SEARCH_ROUTES),
      },

      // ame
      { path: 'complaints', loadChildren: () => import('./components/ame/complaints/complaints.routes').then(m => m.COMPLAINTS_ROUTES) },
      { path: 'crm-user-accesses', loadChildren: () => import('./components/ame/crm-user-accesses/crm-user-accesses.routes').then(m => m.CRM_USER_ACCESSES_ROUTES) },
      { path: 'deliverables', loadChildren: () => import('./components/ame/deliverables/deliverables.routes').then(m => m.DELIVERABLES_ROUTES) },

      // grants management
      { path: 'donors', loadChildren: () => import('./components/grants-management/donors/donors.routes').then(m => m.DONORS_ROUTES) },
      { path: 'grants-management/partners', loadChildren: () => import('./components/grants-management/partners/partners.routes').then(m => m.PARTNERS_ROUTES) },
      {
        path: 'grants-management/partner-user-accesses',
        loadChildren: () => import('./components/grants-management/partner-user-accesses/partner-user-accesses.routes').then(m => m.PARTNER_USER_ACCESSES_ROUTES),
      },
      {
        path: 'grants-management/projects',
        loadChildren: () => import('./components/grants-management/projects/projects.routes').then(m => m.PROJECTS_ROUTES),
      },
      {
        path: 'project-report-schedules',
        loadChildren: () => import('./components/grants-management/project-report-schedules/project-report-schedules.routes').then(m => m.PROJECT_REPORT_SCHEDULES_ROUTES),
      },

      // finance
      { path: 'balzac-books', loadChildren: () => import('./components/finance/balzac-books/balzac-books.routes').then(m => m.BALZAC_BOOKS_ROUTES) },
      {
        path: 'finance/contracts-closures',
        loadChildren: () => import('./components/finance/contracts-closures/contracts-closures.routes').then(m => m.CONTRACTS_CLOSURES_ROUTES),
      },
      {
        path: 'finance/currency-rates',
        loadChildren: () => import('./components/finance/currency-rates/currency-rates.routes').then(m => m.CURRENCY_RATES_ROUTES),
      },
      {
        path: 'finance/financial-sheets',
        loadChildren: () => import('./components/finance/financial-sheet-projects/financial-sheet-projects.routes').then(m => m.FINANCIAL_SHEET_PROJECTS_ROUTES),
      },
      {
        path: 'finance/financial-sheet-user-accesses',
        loadChildren: () => import('./components/finance/financial-sheet-user-accesses/financial-sheet-user-accesses.routes')
          .then(m => m.FINANCIAL_SHEET_USER_ACCESSES_ROUTES),
      },
      {
        path: 'finance/saga/saga-conversions',
        loadChildren: () => import('./components/finance/saga-conversions/saga-conversions.routes').then(m => m.SAGA_CONVERSIONS_ROUTES),
      },
      {
        path: 'finance/saga/saga-referential',
        loadChildren: () => import('./components/finance/saga-referential/saga-referential.routes').then(m => m.SAGA_REFERENTIAL_ROUTES),
      },

      // greening
      { path: 'grasp/grasp-entries', loadChildren: () => import('./components/greening/grasp-entries/grasp-entries.routes').then(m => m.GRASP_ENTRIES_ROUTES) },
      { path: 'grasp/grasp-accesses', loadChildren: () => import('./components/greening/grasp-accesses/grasp-accesses.routes').then(m => m.GRASP_ACCESSES_ROUTES) },
      { path: 'greening/caroot-perimeters', loadChildren: () => import('./components/greening/caroot-perimeters/caroot-perimeters.routes').then(m => m.CAROOT_PERIMETERS_ROUTES) },
      {
        path: 'greening/caroot-emission-factors',
        loadChildren: () => import('./components/greening/caroot-emission-factors/caroot-emission-factors.routes').then(m => m.CAROOT_EMISSION_FACTORS_ROUTES),
      },
      { path: 'greening/caroot-activities', loadChildren: () => import('./components/greening/caroot-activities/caroot-activities.routes').then(m => m.CAROOT_ACTIVITIES_ROUTES) },
      {
        path: 'greening/caroot-report-country-configurations',
        loadChildren: () => import('./components/greening/caroot-report-country-configurations/caroot-report-country-configurations.routes')
          .then(m => m.CAROOT_REPORT_COUNTRY_CONFIGURATIONS_ROUTES),
      },
      {
        path: 'greening/caroot-report-place-configurations',
        loadChildren: () => import('./components/greening/caroot-report-place-configurations/caroot-report-place-configurations.routes')
          .then(m => m.CAROOT_REPORT_PLACE_CONFIGURATIONS_ROUTES),
      },
      { path: 'greening/caroot-reports', loadChildren: () => import('./components/greening/caroot-reports/caroot-reports.routes').then(m => m.CAROOT_REPORTS_ROUTES) },
      {
        path: 'greening/caroot-country-reports',
        loadChildren: () => import('./components/greening/caroot-country-reports/caroot-country-reports.routes').then(m => m.CAROOT_COUNTRY_REPORTS_ROUTES),
      },
      {
        path: 'greening/caroot-user-accesses',
        loadChildren: () => import('./components/greening/caroot-user-accesses/caroot-user-accesses.routes').then(m => m.CAROOT_USER_ACCESSES_ROUTES),
      },

      // logistics
      { path: 'logistics/assets', loadChildren: () => import('./components/logistics/assets/assets.routes').then(m => m.ASSETS_ROUTES) },
      {
        path: 'logistics/asset-user-accesses',
        loadChildren: () => import('./components/logistics/asset-user-accesses/asset-user-accesses.routes').then(m => m.ASSET_USER_ACCESSES_ROUTES),
      },
      {
        path: 'logistics/disposal-plans',
        loadChildren: () => import('./components/logistics/disposal-plans/disposal-plans.routes').then(m => m.DISPOSAL_PLANS_ROUTES),
      },
      { path: 'logistics/inventories', loadChildren: () => import('./components/logistics/inventories/inventories.routes').then(m => m.INVENTORIES_ROUTES) },
      { path: 'logistics/projects', loadChildren: () => import('./components/logistics/projects/projects.routes').then(m => m.LOGISTICS_PROJECTS_ROUTES) },
      {
        path: 'logistics/procurements-main',
        loadChildren: () => import('./components/logistics/procurements-main/procurements-main.routes').then(m => m.PROCUREMENTS_MAIN_ROUTES),
      },
      {
        path: 'logistics/procurement-user-accesses',
        loadChildren: () => import('./components/logistics/procurement-user-accesses/procurement-user-accesses.routes')
          .then(m => m.PROCUREMENT_USER_ACCESSES_ROUTES),
      },
      { path: 'logistics/suppliers', loadChildren: () => import('./components/logistics/suppliers/suppliers.routes').then(m => m.SUPPLIERS_ROUTES) },
      {
        path: 'logistics/supplier-suspend-histories',
        loadChildren: () => import('./components/logistics/supplier-suspend-histories/supplier-suspend-histories.routes')
          .then(m => m.SUPPLIER_SUSPEND_HISTORIES_ROUTES),
      },
      {
        path: 'logistics/supplier-user-accesses',
        loadChildren: () => import('./components/logistics/supplier-user-accesses/supplier-user-accesses.routes')
          .then(m => m.SUPPLIER_USER_ACCESSES_ROUTES),
      },
      { path: 'logistics/waivers', loadChildren: () => import('./components/logistics/waivers/waivers.routes').then(m => m.WAIVERS_ROUTES) },
      { path: 'logistics/phone-lines', loadChildren: () => import('./components/logistics/phone-lines/phone-lines.routes').then(m => m.PHONE_LINES_ROUTES) },

      // programme
      // water-structures and water-networks are explicitly named in their specific routes,
      // grouped here to avoid a circular import
      { path: 'programme', loadChildren: () => import('./components/programme/water.routes').then(m => m.WATER_ROUTES) },
      {
        path: 'programme/water-structure-user-accesses',
        loadChildren: () => import('./components/programme/water-structure-user-accesses/water-structure-user-accesses.routes')
          .then(m => m.WATER_STRUCTURE_USER_ACCESSES_ROUTES),
      },

      // security
      { path: 'security/incidents', loadChildren: () => import('./components/security/incidents/incidents.routes').then(m => m.INCIDENTS_ROUTES) },
      {
        path: 'security/incident-user-accesses',
        loadChildren: () => import('./components/security/incident-user-accesses/incident-user-accesses.routes').then(m => m.INCIDENT_USER_ACCESSES_ROUTES),
      },
      { path: 'security/premises', loadChildren: () => import('./components/security/premises/premises.routes').then(m => m.PREMISES_ROUTES) },
      {
        path: 'security/premises-user-accesses',
        loadChildren: () => import('./components/security/premises-user-accesses/premises-user-access.routes').then(m => m.PREMISES_USER_ACCESS_ROUTES),
      },
      { path: 'security/sec21-forms', loadChildren: () => import('./components/security/sec21-forms/sec21-forms.routes').then(m => m.SEC21_FORMS_ROUTES) },
      { path: 'security/sec19', loadChildren: () => import('./components/security/sec19/sec19.routes').then(m => m.SEC19_ROUTES) },
      {
        path: 'security/premises-lifecycle-user-accesses',
        loadChildren: () => import('./components/security/premises-lifecycle-user-accesses/premises-lifecycle-user-accesses.routes')
          .then(m => m.PREMISES_LIFECYCLE_USER_ACCESSES_ROUTES),
      },
      {
        path: 'security/premises-closure-requests',
        loadChildren: () => import('./components/security/premises-closure-requests/premises-closure-requests.routes').then(m => m.PREMISES_CLOSURE_REQUESTS_ROUTES),
      },

      // transparency
      {
        path: 'transparency/certifications',
        loadChildren: () => import('./components/transparency/screening.routes').then(m => m.SCREENING_ROUTES),
      },
      { path: 'transparency/external-audits', loadChildren: () => import('./components/transparency/external-audits/external-audits.routes').then(m => m.EXTERNAL_AUDITS_ROUTES) },
      { path: 'transparency/pseah-checklist', loadChildren: () => import('./components/transparency/pseah-checklist/pseah-checklist.routes').then(m => m.PSEAH_CHECKLIST_ROUTES) },
      {
        path: 'transparency/transparency-line',
        loadChildren: () => import('./components/transparency/transparency-line/transparency-line.routes').then(m => m.TRANSPARENCY_LINE_ROUTES),
      },
      {
        path: 'transparency/external-audit-firms-and-applicants',
        loadChildren: () => import('./components/transparency/external-audit-firms-and-applicants/external-audit-firms-and-applicants.routes').then(
          m => m.EXTERNAL_AUDIT_FIRMS_AND_APPLICANTS_ROUTES,
        ),
      },
      {
        path: 'transparency/external-audit-user-accesses',
        loadChildren: () => import('./components/transparency/external-audit-user-accesses/external-audit-user-accesses.routes').then(m => m.EXTERNAL_AUDIT_USER_ACCESSES_ROUTES),
      },
      {
        path: 'transparency',
        // here ScreeningEntities and ScreeningRequests are grouped in the same route bundle
        loadChildren: () => import('./components/transparency/screening.routes').then(m => m.SCREENING_ROUTES),
      },
      {
        path: 'transparency/screening-request-user-accesses',
        loadChildren: () => import('./components/transparency/screening-request-user-accesses/screening-request-user-accesses.routes').then(
          m => m.SCREENING_REQUEST_USER_ACCESSES_ROUTES,
        ),
      },

    ],
  },
  // {
  //   path: 'nologin',
  //   component: AppNoLoginComponent
  // }
  // 404
  // {path: '**', redirectTo: PageNotFoundComponent}
]
